import React from "react";
import styled from "styled-components";

import DropdownArrow from "icons/DropdownArrow";

const RoomTypeInputCounter = ({
  handleChange,
  name,
  value,
  unit,
  green = false,
  className,
}) => {
  const handleOnChange = (e) => {
    let inputValue = e.target.value;

    handleChange(name, inputValue);
  };

  const handleOnClick = (dir) => {
    let currValue = value;
    if (dir === "+") {
      currValue++;
    } else if (dir === "-") {
      if (value > 1) currValue--;
    }
    handleChange(name, currValue);
  };

  return (
    <InputWrapper className={className} green={green}>
      <input
        min='1'
        type='number'
        onChange={(e) => handleOnChange(e)}
        value={value}
      />
      {unit && <span>{unit}</span>}
      <CounterWrapper>
        <Counter onClick={() => handleOnClick("+")}>
          <StyledDropdownArrow />
        </Counter>
        <Counter onClick={() => handleOnClick("-")} decrement>
          <StyledDropdownArrow decrement />
        </Counter>
      </CounterWrapper>
    </InputWrapper>
  );
};

export default RoomTypeInputCounter;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 50px;
  border: 1px solid
    ${(props) =>
      props.green ? props.theme.colors.button : props.theme.colors.input};
  background-color: transparent;
  transition: border 0.2s ease;

  &:hover,
  &:focus-within {
    border-color: ${(props) => props.theme.colors.text};
  }
  input[type="number"] {
    -moz-appearance: textfield;
    margin-right: 4px;
  }
  input[type="number"]:hover,
  input[type="number"]:focus {
    -moz-appearance: number-input;
  }
  input {
    width: auto;
    max-width: 25px;
    ${(props) => props.theme.fonts.p}
    border: none;
    background: transparent;
    -webkit-appearance: none;
    text-align: right;

    &:-internal-autofill-previewed {
      background-color: transparent !important;
    }
    &:-internal-autofill-selected {
      background-color: transparent !important;
    }
  }

  span {
    ${(props) => props.theme.fonts.p}
    white-space: nowrap;
  }
`;

const CounterWrapper = styled.div`
  margin: auto 8px auto auto;
`;

const Counter = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  transform: ${(p) => (p.decrement ? "rotate(180deg)" : "0")};
  margin-bottom: ${(p) => (p.decrement ? "0" : "4px")};
  width: 50px;
  height: 23px;
  cursor: pointer;
`;

const StyledDropdownArrow = styled(DropdownArrow)``;
